module.exports = __webpack_public_path__ + "img/levelup-icon-x-deny.64337abe.svg";